import React from "react"
import MetaTags from "react-meta-tags"
import { Container, Row, Col, Card, CardBody } from "reactstrap"

const ComingSoon = () => {
  return (
    <React.Fragment>
      <MetaTags>
        <title>Coming Soon | Katlax Enterprises Pvt Ltd</title>
      </MetaTags>
      <div className="page-content">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6}>
              <Card className="text-center mt-5">
                <CardBody>
                  <h1 className="display-4">Coming Soon</h1>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default ComingSoon
